var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-frappe-chart',{attrs:{"type":"bar","labels":['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],"data":[{ values: [18, 40, 30, 35, 8, 52, 17, -4] }],"colors":['red']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }